import { render, staticRenderFns } from "./HorizontalNavMenuHeaderLink.vue?vue&type=template&id=cc03ef52&"
import script from "./HorizontalNavMenuHeaderLink.vue?vue&type=script&lang=js&"
export * from "./HorizontalNavMenuHeaderLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports